import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';

const PrivacyPolicy = () => {
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <header className="bg-white shadow-sm sticky top-0 z-10">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
                    <Link to="/" className="flex items-center text-gray-600 hover:text-primary transition-colors">
                        <ArrowLeft className="w-5 h-5 mr-2" />
                        Back to Home
                    </Link>
                    <div className="flex items-center space-x-2">
                        <Shield className="w-6 h-6 text-primary" />
                        <span className="font-bold text-gray-900">Privacy Policy</span>
                    </div>
                </div>
            </header>

            <main className="flex-grow max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="bg-white shadow-lg rounded-2xl p-8 md:p-12">
                    <h1 className="text-3xl font-bold text-gray-900 mb-6">Privacy Policy</h1>
                    <p className="text-gray-500 mb-8">Last updated: January 26, 2025</p>

                    <div className="prose prose-blue max-w-none text-gray-600 space-y-6">
                        <p>
                            At Intuit LMS, we take your privacy seriously. This Privacy Policy explains how we collect, use,
                            disclose, and safeguard your information when you visit our website or use our learning management system.
                        </p>

                        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">1. Information We Collect</h2>
                        <ul className="list-disc pl-5 space-y-2">
                            <li><strong>Personal Data:</strong> Name, email address, phone number, and institution details provided during registration.</li>
                            <li><strong>Usage Data:</strong> Information about how you interact with our platform, including access times, pages viewed, and IP address.</li>
                            <li><strong>Student/Faculty Data:</strong> Academic records, enrollment data, and other educational information processed on behalf of institutions.</li>
                        </ul>

                        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">2. How We Use Your Information</h2>
                        <p>
                            We use the information we collect to operate, maintain, and improve our services, including:
                        </p>
                        <ul className="list-disc pl-5 space-y-2">
                            <li>Providing and managing your account.</li>
                            <li>Processing payments (via M-Pesa integration).</li>
                            <li>Communicating with you about updates, security alerts, and support.</li>
                            <li>Analyzing usage trends to enhance user experience.</li>
                        </ul>

                        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">3. Data Security</h2>
                        <p>
                            We implement appropriate technical and organizational measures to protect your personal data against
                            unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over
                            the internet is 100% secure.
                        </p>

                        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">4. Contact Us</h2>
                        <p>
                            If you have questions about this privacy policy, please contact us via our <Link to="/contact-us" className="text-blue-600 hover:underline">Contact Page</Link>.
                        </p>
                    </div>
                </div>
            </main>
            <footer className="bg-gray-900 text-white py-8 text-center">
                <p className="text-gray-400">© 2025 INTUIT LMS. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default PrivacyPolicy;
